
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dj/staff",
      function () {
        return require("private-next-pages/dj/staff/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dj/staff"])
      });
    }
  